import { render, staticRenderFns } from "./contact-list-item.vue?vue&type=template&id=b776462a&scoped=true&"
import script from "./contact-list-item.vue?vue&type=script&lang=js&"
export * from "./contact-list-item.vue?vue&type=script&lang=js&"
import style0 from "./contact-list-item.vue?vue&type=style&index=0&id=b776462a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b776462a",
  null
  
)

export default component.exports